var _excluded = ["image", "description", "imageStyle", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Box, styled, Stack } from '@mui/material';
import DefaultEmptyImg from "./empty";
var EmptyRoot = styled(Stack)(function () {
  return {
    height: '100%'
  };
});
var Empty = function Empty(props) {
  var _props$image = props.image,
    image = _props$image === void 0 ? /*#__PURE__*/React.createElement(DefaultEmptyImg, {
      sx: {
        fontSize: '100px'
      }
    }) : _props$image,
    _props$description = props.description,
    description = _props$description === void 0 ? /*#__PURE__*/React.createElement(Box, {
      sx: {
        color: 'text.auxiliary',
        fontSize: '14px'
      }
    }, "\u6682\u65E0\u6570\u636E") : _props$description,
    imageStyle = props.imageStyle,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    other = _objectWithoutProperties(props, _excluded);
  var imageNode = null;
  var alt = typeof description === 'string' ? description : 'empty';
  if (typeof image === 'string') {
    imageNode = /*#__PURE__*/React.createElement(Box, {
      component: "img",
      alt: alt,
      src: image,
      style: imageStyle
    });
  } else {
    imageNode = image;
  }
  return /*#__PURE__*/React.createElement(EmptyRoot, _extends({
    className: "".concat(className, " cx-empty"),
    direction: "column",
    justifyContent: "center",
    alignItems: "center"
  }, other), imageNode, description);
};
export default Empty;